export default {"src":"/_next/static/media/eu-flag-rounded.b725e817.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};